import { Button } from "antd";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";
import FontFa from "../fontFa/fontFa";
import { useState } from "react";
import { ContentHistoryVersionModal } from "../../pages/document/modal/content-history-version-modal";
import { useSearchParams } from "../../hook/use-search-params";

const replaceHTMLtoTitle = (str: string) => {
  if (!str) return "";
  if (str) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return doc.firstChild?.textContent || "";
  }
};

export const ContentDiffViewer = ({
  oldContent,
  newContent,
  id,
  index,
  isVisibleViewHistoryButton = true,
  cVersionTitle,
  pVersionTitle,
  cVersionSummary,
  ...rest
}: {
  oldContent: string;
  newContent: string;
  id: string;
  isVisibleViewHistoryButton?: boolean;
  index: number;
  cVersionTitle?: string;
  pVersionTitle?: string;
  cVersionSummary?: string;
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { searchParams, replaceSearchParams } = useSearchParams();

  const handleClickScroll = (e: React.MouseEvent<HTMLDivElement>, id: string) => {
    e.preventDefault();
    const titleId = `title-${id}`;
    const element = document.getElementById(titleId);
    element?.focus();
    if (element) {
      element.scrollIntoView({ behavior: "auto", block: "start", inline: "start" });
      searchParams.set("titleId", titleId);
      replaceSearchParams(searchParams);
    }
  };

  const renderRightTitle = (
    <div className="d-flex column justify-content-between align-items-flex-end" style={{ width: "40vw" }}>
      <div>PHIÊN BẢN CẬP NHẬT</div>
      {isVisibleViewHistoryButton && (
        <Button
          icon={<FontFa name="faUserClock" />}
          type="text"
          title="Xem lịch sử chỉnh sửa"
          size="middle"
          onClick={() => setIsOpenModal(true)}
        />
      )}
    </div>
  );

  const renderCountinueTitle = (docTitle: string, index: number) => {
    if (!docTitle && index > 1) return <hr />;
    return (
      <div>
        {index > 1 && <hr />} <div dangerouslySetInnerHTML={{ __html: docTitle || "" }} />
      </div>
    );
  };

  const renderLeftTitle = (
    <div className="d-flex column justify-content-between align-items-flex-end" style={{ width: "40vw" }}>
      <div>PHIÊN BẢN TRƯỚC</div>
    </div>
  );

  return (
    <>
      <ReactDiffViewer
        renderContent={(source) => {
          return (
            <div style={{ width: "42vw" }}>
              <div
                style={{
                  whiteSpace: "normal",
                  padding: "1px",
                  margin: "1px",
                  textAlign: "left",
                  cursor: "pointer",
                }}
                className="scroll-mt-20"
                onClick={(evt) => handleClickScroll(evt, id)}
                dangerouslySetInnerHTML={{ __html: source }}
              />
            </div>
          );
        }}
        oldValue={!oldContent ? "" : replaceHTMLtoTitle(oldContent)}
        newValue={!newContent ? "" : cVersionSummary ?? replaceHTMLtoTitle(newContent)}
        splitView={true}
        showDiffOnly={false}
        hideLineNumbers
        disableWordDiff={true}
        compareMethod={DiffMethod.WORDS_WITH_SPACE}
        leftTitle={index === 0 ? renderLeftTitle : renderCountinueTitle(pVersionTitle || "", index)}
        rightTitle={index === 0 ? renderRightTitle : renderCountinueTitle(cVersionTitle || "", index)}
        {...rest}
      />

      <ContentHistoryVersionModal isOpenModal={isOpenModal} onClose={() => setIsOpenModal(false)} />
    </>
  );
};
